import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider as StoreProvider } from 'react-redux'
import { StyleSheetManager } from 'styled-components'
import { initializeLogger } from './core/debuggers'
import AppThemeProvider from './components/Theme/AppThemeProvider'
import App from './App'
import { store } from './config/store/store'

const root = createRoot(document.getElementById('root'));

initializeLogger({ environment: 'dev' })

root.render(
  <StyleSheetManager disableVendorPrefixes>
    <StoreProvider store={store}>
      <AppThemeProvider>
        <App />
      </AppThemeProvider>
    </StoreProvider>
  </StyleSheetManager>
)
